<template>
  <b-modal
    id="modal-additional-input-discount"
    hide-header
    hide-footer
    centered
    no-close-on-backdrop
    title="Vertically Centered"
    ok-only
    ok-title="Accept"
  >
    <div class="p-2 d-flex justify-content-between">
      <div />
      <h1 class="h4 text-dark fw-bold-700 mb-0 size16">
        Masukkan diskon tambahan % atau Rp
      </h1>
      <feather-icon
        class="text-dark fw-bold-700"
        size="20"
        icon="XIcon"
        @click="$bvModal.hide('modal-additional-input-discount')"
      />
    </div>
    <hr class="mt-0">
    <b-container>
      <b-row class="p-2">
        <b-col cols="12">
          <b-form-group>
            <label for="value-diskon">Jumlah diskon</label>
            <b-input-group class="input-group-merge">
              <input
                v-if="formPayload.discount_type == 'percent'"
                id="value-diskon"
                ref="discountValue"
                :value="formPayload.discount_value"
                type="text"
                class="custom__input pl-2"
                style="width: 65%;"
                @input="getRupiah"
                @change="getRupiah"
              >
              <input
                v-else
                id="value-diskon"
                ref="discountValue"
                :value="formPayload.discount_value"
                type="text"
                class="custom__input pl-2"
                style="width: 65%;"
                @input="getRupiah"
                @change="getRupiah"
              >
              <b-input-group-append is-text>
                <div class="button__group">
                  <b-button
                    id="button--percent"
                    class="button__is--discount"
                    :class="{'active' : formPayload.discount_type == 'percent'}"
                    @click="formPayload.discount_type = 'percent'"
                  >
                    %
                  </b-button>
                  <b-button
                    id="button--discount"
                    class="button__is--discount"
                    :class="{'active' : formPayload.discount_type == 'fixed'}"
                    @click="formPayload.discount_type = 'fixed'"
                  >
                    Rp
                  </b-button>
                </div>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
    </b-container>
    <div class="button__group">
      <b-button
        id="button--cancel"
        class="button__cancel"
        @click="$bvModal.hide('modal-additional-input-discount')"
      >
        Batal
      </b-button>
      <b-button
        v-if="isStock == false"
        class="button__save"
        @click="$store.state.cashier.isAddDiscount == false ? saveDiscount() : addDiscount()"
      >
        Simpan
      </b-button>
      <b-button
        v-if="isStock == true"
        id="button--save"
        class="button__save"
        @click="addDiscount"
      >
        Simpan
      </b-button>
    </div>
  </b-modal>
</template>

<script>
// import { ValidationProvider } from 'vee-validate'
import {
  BFormInput, BRow, BCol, BModal, VBToggle, BButton, BFormGroup, BContainer, BInputGroup, BInputGroupAppend,
} from 'bootstrap-vue'
import {
  checkPermission, successNotification, errorNotification, preformatFloat,
} from '@/auth/utils'
import Cleave from 'cleave.js'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BContainer,
    BRow,
    BCol,
    BModal,
    BFormInput,
    BButton,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
  },
  directives: {
    'b-toggle': VBToggle,
    Ripple,
    cleave: {
      inserted: (el, binding) => {
        // eslint-disable-next-line no-param-reassign
        el.cleave = new Cleave(el, binding.value || {})
      },
      update: el => {
        const event = new Event('input', { bubbles: true })
        setTimeout(() => {
          // eslint-disable-next-line no-param-reassign
          el.value = el.cleave.properties.result
          el.dispatchEvent(event)
        }, 100)
      },
    },
  },
  props: {
    isStock: {
      type: Boolean,
    },
    formData: {
      type: Object,
    },
  },
  data() {
    return {
      money: {
        decimal: '',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: false,
      },
      is_ritel: true,
      is_discount: false,
      formPayload: {
        discount_type: 'percent',
        discount_value: '',
      },
    }
  },
  setup() {
    return {
      checkPermission, successNotification, errorNotification, preformatFloat,
    }
  },
  watch: {
    '$store.state.cashier.discounts': function (value) {
      this.formPayload = {
        discount_type: value.type,
        discount_value: value.discount,
      }
    },
    formData(value) {
      this.formPayload = {
        discount_type: value.type,
        discount_value: value.discount || '',
      }
    },
  },
  methods: {
    getRupiah() {
      let rupiah = this.$refs.discountValue.value
      rupiah = this.formatRupiah(rupiah, '')
      this.formPayload.discount_value = rupiah
    },
    formatRupiah(angka, prefix) {
      const number_string = angka.replace(/[^,\d]/g, '').toString()
      const split = number_string.split(',')
      const sisa = split[0].length % 3
      let rupiah = split[0].substr(0, sisa)
      const ribuan = split[0].substr(sisa).match(/\d{3}/gi)

      if (ribuan) {
        const separator = sisa ? '.' : ''
        rupiah += separator + ribuan.join('.')
      }

      rupiah = split[1] !== undefined ? `${rupiah},${split[1]}` : rupiah
      return prefix === undefined ? rupiah : (rupiah || '')
    },
    // eslint-disable-next-line consistent-return
    addDiscount() {
      const discountValue = parseFloat(this.preformatFloat(this.formPayload.discount_value))
      if (this.formPayload.discount_type === 'percent' && discountValue > 100) {
        this.$swal({
          icon: 'error',
          title: 'Oops!',
          text: 'Maksimal diskon 100%',
        })
        return false
      }
      if (this.formPayload.discount_type === 'percent' && discountValue <= 100) {
        if (this.isStock === true) {
          this.$store.commit('stockWarehouse/setDiscounts', {
            type: this.formPayload.discount_type,
            discount: discountValue,
          })
        } else {
          this.$store.commit('cashier/setDiscounts', {
            type: this.formPayload.discount_type,
            discount: discountValue,
          })
        }
        this.$bvModal.hide('modal-additional-input-discount')
      }
      if (this.formPayload.discount_type === 'fixed') {
        if (this.isStock === true) {
          this.$store.commit('stockWarehouse/setDiscounts', {
            type: this.formPayload.discount_type,
            discount: discountValue,
          })
        } else {
          this.$store.commit('cashier/setDiscounts', {
            type: this.formPayload.discount_type,
            discount: discountValue,
          })
        }
        this.$bvModal.hide('modal-additional-input-discount')
      }
      // this.formPayload = {
      //   discount_type: 'percent',
      //   discount_value: '',
      // }
      // this.clearItem()
    },
    saveDiscount() {
      // eslint-disable-next-line radix
      const price = parseFloat(this.preformatFloat(this.formPayload.discount_value))
      this.$store.dispatch('cart/addDiscountToCartByCart', {
        uuid: this.$store.state.cart.cartUuid,
        payload: {
          discount_type: this.formPayload.discount_type,
          discount_value: price,
        },
      }).then(result => {
        this.formPayload.discount_value = ''
        this.$store.commit('cart/setDiscountCart', result.data.data.discount_value)
        this.$store.commit('cart/setDiscountType', result.data.data.discount_type)
        this.$store.commit('cart/setDiscountTotal', result.data.data.discount_total)
        this.$store.commit('cart/setSubtotalCart', result.data.data.subtotal)
        this.$store.commit('cart/setTotalPrice', result.data.data.total)
        this.$store.commit('cart/setTotalBuy', result.data.data.items.length)
        this.$store.commit('cart/setCartUuid', result.data.data.uuid)
        this.$store.commit('cart/setResultCartActive', result.data.data)
        this.$store.commit('cashier/setProduct', result.data.data.items.length)
        localStorage.setItem('cartUuid', result.data.data.uuid)
        localStorage.setItem('cash_total_payment', result.data.data.total)
        successNotification(this, 'Success', 'Diskon telah ditambahkan ke cart')
        this.$bvModal.hide('modal-additional-input-discount')
      }).catch(err => {
        if (err.response.data.meta.messages) {
          errorNotification(this, 'Oops!', err.response.data.meta.messages)
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '/src/assets/scss/variables/_variables.scss';

#modal-additional-input-discount {
  .modal-dialog {

    .modal-content {
      background: #FCFCFC;
      border-radius: 16px;

      .modal-body {
        padding: 0;
        .form-group {
          label {
            font-size: 14px;
            color: $dark;
            font-weight: 600;
          }
          input {
            background: $light--background;
            border: none;
            border-radius: 8px;
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
            height: 52px;
            color: $dark;
            font-weight: 600;
          }
          .input-group {
            .input-group-append {
              .input-group-text {
                border: 1px solid $light--background;
                background-color: $light--background;
                color: $light--description;
                border-radius: 8px;
                border-top-left-radius: 0;
                border-bottom-left-radius: 0;
              }
            }
          }
        }
        .button__group {
          display: flex;
          width: 100%;

          .button__is--discount {
            background: transparent !important;
            border: none !important;
            color: $light--description !important;

            &.active {
              background: #FFFFFF !important;
              border: none !important;
              color: $dark !important;
            }
          }

          .button__cancel {
            background-color: #FFFFFF !important;
            border-color: #fff !important;
            color: $dark !important;
            box-shadow: 0px -2px 8px rgba(0, 0, 0, 0.04);
            border-radius: 0px 0px 0px 16px;
            width: 100%;
            height: 72px;
            font-size: 16px;
            font-weight: 800;
          }

          .button__save {
            background-color: #45B6AB !important;
            border-color: #45B6AB !important;
            box-shadow: 0px -2px 8px rgba(0, 0, 0, 0.04);
            border-radius: 0px 0px 16px 0px;
            width: 100%;
            height: 72px;
            font-size: 16px;
            font-weight: 800;
          }

        }
      }
    }
  }
}
</style>
